import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { getTemperature } from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p00043-card-pac-statut',
  templateUrl: './p00043-card-pac-statut.component.html',
  styleUrls: ['./p00043-card-pac-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00043CardPacStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttonMode = [
      {
        title: 'P00043.dashboard.card.status.off',
        icon: 'off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00043.dashboard.card.status.on',
        icon: 'on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttons = [
      {
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
      },
      {
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
      },
      {
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.PAC,
      FunctionOnglet.CONTROL,
      this.actionStack!.getValue('paPModeRegulation') === 0
        ? this.translateService.instant('P00043.dashboard.card.title.warm')
        : this.translateService.instant('P00043.dashboard.card.title.cold'),
    );
  }

  protected readonly getTemperature = getTemperature;
}
